import type { ColumnDef } from "@tanstack/react-table"
import type { TFunction } from "i18next"
import { PackageIcon } from "lucide-react"

import { ClipboardButton } from "@/components/commons/clipboard-button"
import { formatMoney } from "@/helpers/format"
export const createItemsDetailsColumns = (
  t: TFunction
): ColumnDef<ItemsDetailsColumnsType>[] => [
  {
    header: t("orders.itemsTable.product"),
    accessorKey: "name",
    cell: ({ row }) => (
      <div className="flex items-center gap-3">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-muted">
          <PackageIcon
            size={16}
            className="text-muted-foreground"
          />
        </div>
        <div className="flex flex-col">
          <span className="font-medium">
            {row.original.name}
          </span>
          {row.original.productId && (
            <span className="text-xs text-muted-foreground">
              ID: {row.original.productId}
            </span>
          )}
        </div>
      </div>
    ),
    footer: () => (
      <span className="font-semibold">
        {t("common.total")}
      </span>
    ),
  },
  {
    header: t("orders.itemsTable.sku"),
    accessorKey: "sku",
    enableHiding: false,
    cell: ({ row }) => (
      <div className="flex items-center gap-1">
        <code className="rounded bg-muted px-1.5 py-0.5 text-xs">
          {row.original.sku || "-"}
        </code>
        {row.original.sku && (
          <ClipboardButton
            text={row.original.sku}
            variant="ghost"
            className="h-6 w-6"
          />
        )}
      </div>
    ),
  },
  {
    header: t("orders.itemsTable.quantity"),
    accessorKey: "quantity",
    cell: ({ row }) => (
      <span className="font-medium">
        {row.original.quantity}
      </span>
    ),
    footer: ({ table }) => {
      const total = table
        .getFilteredRowModel()
        .rows.reduce(
          (sum, row) => sum + row.original.quantity,
          0
        )
      return <span className="font-semibold">{total}</span>
    },
  },
  {
    header: t("orders.itemsTable.unitPrice"),
    accessorKey: "price",
    cell: ({ row }) => (
      <span className="tabular-nums">
        {formatMoney(row.original.price / 100)}
      </span>
    ),
  },
  {
    header: t("orders.itemsTable.subtotal"),
    accessorKey: "subtotal",
    cell: ({ row }) => (
      <span className="font-medium tabular-nums">
        {formatMoney(
          (row.original.price * row.original.quantity) / 100
        )}
      </span>
    ),
    footer: ({ table }) => {
      const total = table
        .getFilteredRowModel()
        .rows.reduce(
          (sum, row) =>
            sum +
            row.original.price * row.original.quantity,
          0
        )
      return (
        <span className="font-semibold tabular-nums text-primary">
          {formatMoney(total / 100)}
        </span>
      )
    },
  },
]
